export default {"src":"/_next/static/media/scale-icon.6a0b7c1d.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};